import 'react-app-polyfill/ie11'; 
import 'react-app-polyfill/stable';
// @ts-ignore
// eslint-disable-next-line
import KeenBowImageEdit  from "../../../libs/editor/bundle";
import {useEffect, useRef, useState} from "react";
import Config from 'config/config';
import CanvasKitInit from "canvaskit-wasm";
// import CanvasKitWasm from "canvaskit-wasm/bin/canvaskit.wasm";

// @ts-ignore
// import CanvasKitWasm from 'http://172.23.9.7:6008/res/web/libs/canvaskit.wasm';
// import CanvasKitWasm from 'https://res.mockuplabs.ai/web/libs/canvaskit.wasm';

import { useHttpContext } from 'context/HttpContext';
import { useLoadingContext } from 'context/LoadingLayout';
import { LayerItem } from './right/Toolskit';
import { ProjectInfo } from './Detail';
import Stats from 'libs/utils/stats';


export default function MockupEditor(props: {
    action: Action | undefined,
    project : ProjectInfo,
    onDataListener : (params: EventCallbackParams) => void
}) {
    const loadingContext = useLoadingContext();
    const parentElement = useRef<HTMLDivElement>(null);
    const [size, setSize] = useState<CanvasSize>();
    const [mockupApi, setMockupApi] = useState<MockupApiInterface>();
    const httpContent = useHttpContext();
    const [ isSetServer, setIsSetServer ] = useState<boolean>(false);
    const { action, onDataListener, project } = props ;
    const [ callbackStatus, setCallbackStatus ]= useState<number>(0);
    const [ callbackList, setCallbackList ] = useState<EventCallbackParams[]>([]);

    const divId = 'mockupEditorScope';

    const notifyCallback = (data : EventCallbackParams, isQuickExec : boolean = false) => {
        if(isQuickExec){
            return onDataListener(data) ;
        }
        setCallbackList((list: EventCallbackParams[]) => {
            return [...list, data];
        } )
    }

    useEffect(() => {
        // 当前无执行的callback，且是就绪状态
        if(callbackStatus === 0 && callbackList && callbackList.length){
            const firstCallback = callbackList[0] ;
            setCallbackList((list: EventCallbackParams[]) => {
                const tempList = [...list];
                tempList.shift();
                return tempList ;
            })
            setCallbackStatus(1);
           
            firstCallback && onDataListener(firstCallback);
            setTimeout(() => {
                setCallbackStatus(0);
            }, 40);
        }
    }, [ callbackList, callbackStatus ])


    useEffect(() => {
        if(parentElement.current){
            const width = parentElement.current.clientWidth,
                height = parentElement.current.clientHeight;
            // @ts-ignore
            //初始化画板
            new KeenBowImageEdit();
            setSize({width,height})

            // @ts-ignore3
            // 实例后，初始化画布
            KeenBowImageEdit.instance.initCavas(CanvasKitInit, Config.libWasmUrl, divId,width * 33,height * 33,function (code: any,result: any) {
                // code :0 成功 
                if(!code){
                    // @ts-ignore
                    // KeenBowImageEdit.instance.modifyAllTitleEditParameter(0, 0, 12, 0, 1, 1, 5, 5, 0, -40, 18, 13);

                    // console.info('registerLogCallBack');

                    // @ts-ignore
                    // KeenBowImageEdit.instance.registerLogCallBack((log: string) => {
                    //     console.info('callback log', log);
                    // })

                    // setTimeout(() => {
                        // @ts-ignore
                        setMockupApi(KeenBowImageEdit.instance);
                        loadingContext?.setIsLoadingLayout(false);
                    // },500)
                    notifyCallback({
                        type: EventCallbackParamsType.EDITOR_INIT_FINISHED,
                    }, true);
                }
            })
        }
    },[])

    useEffect(() => {
        // 触发设置地址
        setServerAddress();
    },[ project.baseUrl ])

    useEffect(() => {
        // 服务地址已正确设置且有项目数据，则加载数据
        if(isSetServer && project.content){
            const urls = project.urls ;
            let paramsUrls = '{}';
            if(urls){
                const rurls : any = {} ;
                Object.keys(urls).forEach(key => {
                    let url = urls[key] as string;
                    const isDynamicUrl = url.endsWith('6.bin');
                    rurls[key] = url + '?' + project.projectId + (isDynamicUrl ? new Date().getTime() : '');
                });
                paramsUrls = JSON.stringify(rurls);
            }
            mockupApi?.loadProjectData(project.content, paramsUrls, (code: number) => {
            });
        }
    },[ project.content, isSetServer ])

    useEffect(() => {
        if(mockupApi){
            // 注册事件
            mockupApi.registerEventsCallBack((type: any, data: any) => {
                // console.info('event callback', type, data)

                let callbackParams : EventCallbackParams | undefined = undefined ;
                switch(type){
                    case 0: // 对象选择
                    case 1: // 移动结束
                    case 7: // 添加图像（更新)后会自动选择， 不会触发0
                    case 16: //改变类型
                    case 27: // 粘贴图像
                        {
                        const isSelectedMore = Array.isArray(data);
                        if(isSelectedMore){
                            callbackParams = {
                                type: EventCallbackParamsType.OBJECT_CANCEL_SELECT,
                                data : true
                            }
                        }else{
                            const _data = {...data} ;
                            let mockupObject;
                            
                            // const pos = mockupApi?.position2px(mockupObject.mPosX, mockupObject.mPosY);
                            // const clientRect = document.getElementById(divId)?.getBoundingClientRect();
                            
                            // const size = mockupApi?.size2px(mockupObject.mShowWidth, mockupObject.mShowHeight);
                            // // console.info('size', size)
                            // mockupObject.globalLeft = pos[0] + (clientRect?.left || 0);
                            // mockupObject.globalTop = pos[1] + (clientRect?.top || 0);
                            // mockupObject.globalWidth = size[0];
                            // mockupObject.globalHeight = size[1];
                            if(_data.type == 3){
                                mockupObject = _data as MockupTextObject ;
                                mockupObject.fontSize = Math.round(mockupApi.rulerToFloat(data.fontSize))
                                mockupObject.lineHeight = Math.round(mockupApi.rulerToFloat(data.lineHeight))
                                mockupObject.letterSpacing = Math.round(mockupApi.rulerToFloat(data.letterSpacing))
                            }else{
                                mockupObject = _data as MockupObject ;
                                if(mockupObject.mapUUId){
                                    mockupObject = {...data, parent : mockupApi.getImageDataByUuid(mockupObject.mapUUId)}
                                }
                            }
                            
                            callbackParams = {
                                type: EventCallbackParamsType.OBJECT_SELECT,
                                data : mockupObject,
                                callbackType : type
                            }
                        }
                        
                        break;
                    }
                    case 4: // 取消选择
                    case 5 :// 删除时取消选中
                        callbackParams = {
                            type: EventCallbackParamsType.OBJECT_CANCEL_SELECT,
                            data : false
                        }
                        break; 
                    case 19: // 画板缩放
                        notifyCallback({
                            type: EventCallbackParamsType.PANEL_SCALE_CALLBACK,
                            data: `${Math.ceil(data * 100)}`
                        }, true);
                        break;
                }
                if(callbackParams){
                    notifyCallback(callbackParams as EventCallbackParams)
                }

                switch(type){
                    // 移动结束事件 / 旋转结束事件 / 缩放结束事件
                    case 1: case 2: case 3: 
                    // 删除图像 / 更新图像
                    case 5: case 7: 
                    // 向量图与底图相互转换  | 文本转向量图
                    case 16: 
                    case 20: case 21: // 撤销/恢复
                    case 26: // 图层相关修改
                    case 27: // 粘贴
                    case 29: // 文本输入结束
                        notifyCallback({
                            type: EventCallbackParamsType.EDITOR_CHANGE,
                            data : `${mockupApi.getUndoState() ? 1 : 0}:${mockupApi.getRndoState() ? 1 : 0}`
                        })
                }

                if(type == 23){ // base64变化 
                    notifyCallback({
                        type: EventCallbackParamsType.ITEM_BASE64_CHANGE,
                        data : data 
                    })
                    
                }else if(type == 25){
                    notifyCallback({
                        type: EventCallbackParamsType.MOUSE_CHANGE_CALLBACK,
                        data : data 
                    })
                }

                // 缩放结束  |  删除  |  添加    |   选中  || 移动结束
                else if(type == 3 || type == 5 || type == 6 || type == 0 || type == 1 || type == 4){
                    const _data = {...data} ;
                    if(_data && _data.type === 3 && type !== 5){
                        let mockupObject = _data as MockupTextObject ;
                        mockupObject.fontSize = Math.round(mockupApi.rulerToFloat(data.fontSize))
                        mockupObject.lineHeight = Math.round(mockupApi.rulerToFloat(data.lineHeight))
                        mockupObject.letterSpacing = Math.round(mockupApi.rulerToFloat(data.letterSpacing))
                        notifyCallback({
                            type: EventCallbackParamsType.TEXT_EDITING_CALLBACK,
                            data : mockupObject
                        })
                    }else{
                        notifyCallback({
                            type: EventCallbackParamsType.TEXT_EXIT_CALLBACK
                        })
                    }
                }
                else if(type == 26 || type == 29){ // 图层修改触发 | 文本输入结束
                    notifyCallback({
                        type: EventCallbackParamsType.LAYER_MODIFY_CALLBACK,
                    })
                } else if(type == 1){ // 移动元素之后触发
                    notifyCallback({
                        type: EventCallbackParamsType.MOVED_CALLBACK,
                        data
                    })
                }

                if(type == 7){ // 添加元素成功后，需要单独触发
                    notifyCallback({
                        type: EventCallbackParamsType.ADD_ELEMENT_SUC_CALLBACK,
                        data
                    })
                }
            })

            // 初始化相关数据
            setServerAddress();
        }
    },[mockupApi])

    // 设置地址
    const setServerAddress = () => {
        if(!isSetServer && mockupApi){
            mockupApi.setServerAddress(Config.aiMockupDepthUrl, Config.aiMockupProcessImageUrl, Config.aiInpaintUrl, Config.aiSegmentationUrl, '');
            mockupApi.modifyRenderLight(0.9) // 修改光影渲染参数 [0,1]， 默认为1
            // mockupApi.setRulerScale(0.8)
            setIsSetServer(true);
        }
    }

    useEffect(() => {
        if(!action) return ;
        switch(action.name){
            case ActionName.CHANGE_MOUSE_MODE: // 切换鼠标模式
                mockupApi?.switchMouseType(action.params ? action.params : 0);
                break;
            case ActionName.INIT_EDITOR_DATA: // 初始化编辑器数据
                setTimeout(() => {
                    mockupApi?.loadProjectData(action.params, (code: number) => {
                    });
                },30);
                break;
            case ActionName.LOADING_IMAGE: // 加载图片
                // console.info('LOADING_IMAGE')
                mockupApi?.stopEraseDraw(); // 先不做校验调用解决问题,后续优化只在画笔模式下才调用??!!
                mockupApi?.addImage(2, action.params, (code: number, result: string) => {
                    if(code === 0){
                        Stats.google('Uploaded successfully');
                    }
                })
                break;
            case ActionName.ADD_IMAGES: // 批量加载向量图片
                const imagesObject = action.params as ImagesObject ;
                // console.info('LOADING_IMAGE')
                mockupApi?.stopEraseDraw(); // 先不做校验调用解决问题,后续优化只在画笔模式下才调用??!!
                mockupApi?.addVectorImageDatasByArrary(imagesObject.images || [], imagesObject.maxCol || 3, imagesObject.space, imagesObject.width, imagesObject.height, (code: number, result: string) => {
                })
                break;
            case ActionName.ADD_BACKGROUNDS:{ // 批量加载底图
                const imagesObject = action.params as ImagesObject ;
                // console.info('LOADING_IMAGE')
                mockupApi?.stopEraseDraw(); // 先不做校验调用解决问题,后续优化只在画笔模式下才调用??!!
                mockupApi?.addBackgroundImageDatasByArrary(imagesObject.mapJsons || [], imagesObject.maxCol || 3, imagesObject.space, imagesObject.width, imagesObject.height, (code: number, result: string) => {
                })
                break;
            }
            case ActionName.GENERATE_MOCKUPS:{ // 批量转底图
                const mockupsObject = action.params as BatchMockupsObject ;
                // console.info('LOADING_IMAGE')
                mockupApi?.stopEraseDraw(); // 先不做校验调用解决问题,后续优化只在画笔模式下才调用??!!
                mockupApi?.generateBackgroundImageMapJson(mockupsObject.images, mockupsObject.folderUrl, mockupsObject.timeSpan, (code: number, result: string) => {
                    console.info(code, result);
                })
                break;
            }
            case ActionName.REPLACE_IMAGE: // 替换图片
                mockupApi?.updateSelectImage(action.params, (code: number, result: string) => {
                })
                break;
            case ActionName.MOCKUP: // 转mockup
                const mockupUUID = action.params ;
                mockupApi?.transformImageTypeInSelect((code: number, result: any) => {
                    // console.info('MOCKUP', code)
                    if(!code){
                        httpContent?.response(0, 'Successfully generated as mockup')

                        Stats.google('Generate mockup successfully');
                        // notifyCallback({
                        //     type: EventCallbackParamsType.OBJECT_SELECT,
                        //     data: result
                        // })
                    }else if(code === -1){
                        // console.info('MOCKUP', result)
                        httpContent?.response(100, 'Mockup generation failed')
                        
                        Stats.google('Generate mockup failed');
                    }else if(code == 1){ // 正在转换中
                        // notifyCallback({
                        //     type: EventCallbackParamsType.MOCKUP_COVERTING,
                        //     data: mockupUUID
                        // })
                    }
                    if(code < 1){
                        notifyCallback({
                            type: EventCallbackParamsType.ACTION_FINISH,
                            data: mockupUUID
                        })
                    }
                });
                break;
            case ActionName.VECTOR: // 转向量图
                mockupApi?.merageMockUpImagesToSingleImage((code: number, result: any) => {
                    if(!code){
                        httpContent?.response(0, 'Rasterization successful')
                        notifyCallback({
                            type: EventCallbackParamsType.ACTION_FINISH,
                            data: result.uuid
                        })
                    }
                });
                break;
            case ActionName.VECTOR_ON_MOCKUP_SETTING: // 底图上的向量图属性设置
                const fineTuning = action.params as FineTuningObject ;
                // console.info('fine tuning', fineTuning)
                mockupApi?.modifyVectorImageParameter(fineTuning.saturation * -1, fineTuning.opacity, fineTuning.contrast, fineTuning.brightness, fineTuning.tileMode || 0);
                break;

            case ActionName.IMAGE_SHOW_LOADING:
                mockupApi?.showImageLoadingByUuid(action.params as string, 'Loading...')
                break;
            case ActionName.IMAGE_HIDDEN_LOADING:
                mockupApi?.hiddenImageLoadingByUuid(action.params as string)
                break;
            
            case ActionName.DOWNLOAD: // 下载
                mockupApi?.saveSelectImageToBase64((code: number, result: string) => {
                    if(!code){
                        onDataListener({
                            type: EventCallbackParamsType.DOWNLOAD_CALLBACK ,
                            data: result
                        })   
                    }
                })
                break;
            case ActionName.VECTOR_REMOVE_BACKGROUD: // 去除背景
            case ActionName.VECTOR_HD_UPSCALE: // 转高清
                mockupApi?.saveSelectImageSrcToBase64((code: number, result: string) => {
                    if(!code){
                        onDataListener({
                            type: action.name == ActionName.VECTOR_REMOVE_BACKGROUD && EventCallbackParamsType.VECTOR_REMOVE_BACKGROUD_CALLBACK
                                || EventCallbackParamsType.VECTOR_HD_UPSCALE_CALLBACK ,
                            data: result
                        })   
                    }
                })

                break;
            case ActionName.GET_EDITOR_DATA: // 获取编辑器数据
                mockupApi?.exportProjectData((code: number, data: string) => {
                    let resultData = undefined ;
                    // console.info('exportProjectData', code, data);
                    if(!code){
                        mockupApi?.captureThrumbailImage((code: number, result: string) => {
                            // console.info('captureThrumbailImage', code ,result)
                            resultData = {
                                data: data,
                                previewImage: !code ? result : null
                            }
                        });
                    }else if(code == -1){ // 无数据
                        // onDataListener({
                        //     type: EventCallbackParamsType.GET_EDITOR_DATA_CALLBACK,
                        //     data: ""
                        // })  
                        resultData = {
                            data: '',
                            previewImage: null
                        }
                    }
                    if(resultData){
                        onDataListener({
                            type: EventCallbackParamsType.GET_EDITOR_DATA_CALLBACK,
                            data: resultData
                        })   
                    }
                });
                break;

            case ActionName.UPDATE_PANEL_SCALE: // 修改画布比例
                mockupApi?.setRulerScale(+(action.params as string));
                break; 
            case ActionName.GET_SELECTED_OBJECT_DATA: // 获取选中对象的数据
                {
                    const mockupObject = mockupApi?.getSelectImageData() as MockupObject;
                    const pos = mockupApi?.position2px(mockupObject.mPosX, mockupObject.mPosY);
                    const clientRect = document.getElementById(divId)?.getBoundingClientRect();
                    
                    const size = mockupApi?.size2px(mockupObject.mShowWidth, mockupObject.mShowHeight);
                    if(pos && size){
                        mockupObject.globalLeft = pos[0] + (clientRect?.left || 0);
                        mockupObject.globalTop = pos[1] + (clientRect?.top || 0);
                        mockupObject.globalWidth = size[0];
                        mockupObject.globalHeight = size[1];
                    }
                    
                    onDataListener({
                        type: EventCallbackParamsType.GET_SELECTED_OBJECT_DATA_CALLBACK,
                        data: mockupObject
                    })   
                    break;
                }
                break;
            // =============== 向量图画笔(AI消除) ==============
            case ActionName.VECTOR_AI_ERASE_MAN_START: // 开启手动画笔
                // console.info('s22 VECTOR_AI_ERASE_MAN_START startManAIErase')
                mockupApi?.startManAIErase((code: number) => {
                });
                // 自动返回画笔大小
                onDataListener({
                    type: EventCallbackParamsType.GET_PEN_SIZE_CALLBACK,
                    data: mockupApi?.getDrawPenWidth()
                })  
                break;
            case ActionName.VECTOR_AI_ERASE_CIRCLE_START: // 开启圈选画笔
                mockupApi?.startCicleAIErase();
                break;
            case ActionName.VECTOR_AI_ERASE_CLEAR: // 开始AI消除
                mockupApi?.startAIErase((code: number) => {
                    if(!code){
                        onDataListener({
                            type: EventCallbackParamsType.PEN_CONFIRM_CALLBACK,
                        })  

                        Stats.google('Erased')
                    }
                });
                break;
            case ActionName.VECTOR_AI_ERASE_CLOSE: // 关闭画笔
                mockupApi?.stopEraseDraw();
                onDataListener({
                    type: EventCallbackParamsType.ERASE_DRAW_EXIT_CALLBACK,
                }) 
                break;
            case ActionName.SETTING_PEN_SIZE: // 设置画笔大小
                mockupApi?.setDrawPenWidth(action.params);
                break;
            // ================ 底图智能画笔 ==========
            case ActionName.MOCKUP_AI_AREA_START: // 开启区域画笔
                mockupApi?.startAreaEdit((code: number) => {
                    onDataListener({
                        type: EventCallbackParamsType.MOCKUP_AI_AREA_READY,
                    })  
                });
                break;
            case ActionName.MOCKUP_AI_AREA_SEITCH_EDIT_TYPE: // 切换画笔
                mockupApi?.switchAreaEditType(+(action.params as string), (code: number) => {
                    if(code == 1000 || code == 1001){
                        onDataListener({
                            type: EventCallbackParamsType.MOCKUP_AI_AREA_CHOICE_STATUS,
                            data: `1`
                        })  
                    }
                })
                break;
            case ActionName.MOCKUP_AI_AREA_PROCESS: // 生效
                mockupApi?.processAreaEdit((code: number) => {
                    if(!code){
                        notifyCallback({
                            type: EventCallbackParamsType.MOCKUP_AI_AREA_PROCESS_CALLBACK
                        })
                        notifyCallback({
                            type: EventCallbackParamsType.EDITOR_CHANGE,
                            data : `${mockupApi.getUndoState() ? 1 : 0}:${mockupApi.getRndoState() ? 1 : 0}`
                        })

                        Stats.google('Selected area')
                    }
                })                
                break;
            case ActionName.MOCKUP_AI_AREA_RESET: // 重置
                mockupApi?.clearAreaEdit();
                break;  

            // ================ 底图画笔(废弃) ==========
            // case ActionName.MOCKUP_AREA_START: // 开启区域画笔
            //     mockupApi?.startAreaErase((code: number) => {
            //     });
            //     break;
            // case ActionName.MOCKUP_PEN_SWITCH: // 切换区域|圈选画笔
            //     mockupApi?.switchAreaEraseType(+(action.params || 1));
            //     break;
            // case ActionName.MOCKUP_CONFIRM: // 确认区域画笔
            //     mockupApi?.processAreaErase((code: number) => {
            //         onDataListener({
            //             type: EventCallbackParamsType.PEN_CONFIRM_CALLBACK,
            //         })  
            //     });
            //     break;
            // ================ 底图智能画笔(废弃) ==========
            // case ActionName.MOCKUP_AI_AREA_START: // 开启区域画笔
            //     mockupApi?.startAlAreaErase((code: number) => {
            //         onDataListener({
            //             type: EventCallbackParamsType.MOCKUP_AI_AREA_READY,
            //         })  
            //     });
            //     break;
            // case ActionName.MOCKUP_AI_PEN_SWITCH: // 切换区域|圈选画笔
            //     mockupApi?.switchAIAreaEraseType(+(action.params || 1));
            //     break;
            // case ActionName.MOCKUP_AI_ANALYSIS: // 开始智能分析
            //     mockupApi?.analysisAIAreaErase((code: number) => {
            //     });
            //     break;
            // case ActionName.MOCKUP_AI_CONFIRM: // 确认区域画笔
            //     mockupApi?.processAIAreaErase((code: number) => {
            //         onDataListener({
            //             type: EventCallbackParamsType.PEN_CONFIRM_CALLBACK,
            //         })  
                    
            //         Stats.google('Selected area')
            //     });
            //     break;
            // ================  图层 ================
            case ActionName.TOOLSKIT_REDO: // 上一步
                mockupApi?.redo();
                // onDataListener({
                //     type: EventCallbackParamsType.EDITOR_CHANGE,
                //     data : `${mockupApi?.getUndoState() ? 1 : 0}:${mockupApi?.getRndoState() ? 1 : 0}`
                // })
                break;
            case ActionName.TOOLSKIT_UNDO: // 下一步
                mockupApi?.undo();
                // onDataListener({
                //     type: EventCallbackParamsType.EDITOR_CHANGE,
                //     data : `${mockupApi?.getUndoState() ? 1 : 0}:${mockupApi?.getRndoState() ? 1 : 0}`
                // })
                break;
            case ActionName.GET_LAYER_LIST:  // 获取图层列表
                const listCallback = (list: any) : LayerItem[] => {
                    const layerList : LayerItem[] = [] ;
                    for(let i = 0, len = list.length;i < len ;i ++){
                        const item = list[i];
                        const layerItem : LayerItem = {
                            uuid: item.uuid,
                            parentUuid: item.mapUUId || 0,
                            type: item.type,
                            isExpand : false,
                            isHide : !!mockupApi?.getItemDataHiddenStateByUuid(item.uuid),
                            isUnlocked : mockupApi?.getItemDataLockStateByUuid(item.uuid)
                        }
                        if(layerItem.type == 1){
                            const childrenList = listCallback(mockupApi?.getSecondaryItemsDatabyUUid(item.uuid));
                            if(childrenList && childrenList.length){
                                layerItem.children = childrenList ;
                            }
                        }else if(layerItem.type == 3){
                            layerItem.text = item.text || ''
                        }
                        layerList[i] = layerItem ;
                    }
                    return layerList ;
                }

                onDataListener({
                    type: EventCallbackParamsType.GET_LAYER_LIST_CALLBACK,
                    list : listCallback(mockupApi?.getFirstItemsData() || [])
                })  
                break;
            case ActionName.LAYER_LOCKED_STATE: // 图层锁定/解锁
                let layerItem = action.params as LayerItem ;
                mockupApi?.modifyItemDataLockStateByUuid(layerItem.uuid, layerItem.isUnlocked || false);
                break;
            case ActionName.LAYER_HIDE_STATE: // 图层隐藏/显示
                let lockedLayerItem = action.params as LayerItem ;
                mockupApi?.modifyItemDataHiddenStateByUuid(lockedLayerItem.uuid, lockedLayerItem.isHide || false);
                mockupApi?.updateCanvas();
                break;
            case ActionName.LAYER_POSITION : // 图层定位
                mockupApi?.positioningToImageByUuid(action.params as string);
                break;
            case ActionName.LAYER_SORT: // 图层排序
                const uuids = action.params && (action.params as string).split(',') || [];
                if(uuids.length == 2){
                    mockupApi?.swapFirstItemDataByUuid(uuids[0],uuids[1])
                }
                break;
            
            // ============ 智能换色 ==================
            case ActionName.SMART_COLOR_START: // 开启智能换色
                mockupApi?.startColorEdit((code: number) => {
                    if(code == 0){
                        onDataListener({
                            type: EventCallbackParamsType.SMART_COLOR_AI_READY
                        }) 
                    }else if(code == 1000 || code == 1001){
                        onDataListener({
                            type: EventCallbackParamsType.SMART_COLOR_CHOICE_STATUS,
                            data: `1`
                        })  
                    }
                })
                break;
            case ActionName.SMART_COLOR_SWITCH_TYPE: // 切换画笔
                mockupApi?.switchColorEditType(+(action.params as string), (code: number) => {
                    if(code == 1000 || code == 1001){
                        onDataListener({
                            type: EventCallbackParamsType.SMART_COLOR_CHOICE_STATUS,
                            data: `1`
                        })  
                    }
                })
                break;
            case ActionName.SMART_COLOR_SETTING: { // 设置属性
                const param = action.params as SmartColorFineTuningObject ;
                mockupApi?.modifyColorEditParameter(param?.color || '', param.saturation * -1, param.opacity, param.contrast, param.brightness)
                break;
            }
            case ActionName.SMART_COLOR_PROCESS: // 生效
                mockupApi?.processColorEdit((code: number) => {
                    if(!code){
                        notifyCallback({
                            type: EventCallbackParamsType.SMART_COLOR_PROCESS_CALLBACK
                        })
                        notifyCallback({
                            type: EventCallbackParamsType.EDITOR_CHANGE,
                            data : `${mockupApi.getUndoState() ? 1 : 0}:${mockupApi.getRndoState() ? 1 : 0}`
                        })

                        Stats.google('Change color')
                    }
                })                
                break;
            case ActionName.SMART_COLOR_RESET: // 重置
                mockupApi?.clearColorEditParameter();
                break;  
            
            // ============ 智能换色(废弃) =============
            // case ActionName.SMART_COLOR_START:  // 开启智能换色
            //     mockupApi?.startAIColorErase((code: number) => {
            //         if(code == 0){
            //             onDataListener({
            //                 type: EventCallbackParamsType.SMART_COLOR_AI_READY
            //             }) 
            //         }else if(code == 1000 || code == 1001){
            //             onDataListener({
            //                 type: EventCallbackParamsType.SMART_COLOR_CHOICE_STATUS,
            //                 data: `1`
            //             })  
            //         }
            //     });
            //     break;
            // case ActionName.SMART_COLOR_SETTING: // 设置属性
            //     const param = action.params as SmartColorFineTuningObject ;
            //     mockupApi?.modifySelectAreaImageParameter(param?.color || '', param.saturation * -1, param.opacity, param.contrast, param.brightness)
            //     break;
            // case ActionName.SMART_COLOR_PROCESS: // 处理智能换色结果并刷新画板
            //     mockupApi?.processAIColorErase((code: number) => {
            //         if(!code){
            //             onDataListener({
            //                 type: EventCallbackParamsType.SMART_COLOR_PROCESS_CALLBACK
            //             })
            //         }
            //     })
            //     break;
            // case ActionName.SMART_COLOR_MAN_START:          // 开启手动涂抹画板且开启换色功
            //     mockupApi?.startManColorDooleErase((code: number) => {
            //     });
            //     onDataListener({
            //         type: EventCallbackParamsType.GET_PEN_SIZE_CALLBACK,
            //         data: mockupApi?.getDrawPenWidth()
            //     }) 
            //     break;
            // case ActionName.SMART_COLOR_MAN_SWITCH_TYPE:     // 手动涂抹画笔切换(针对向量图)
            //     mockupApi?.switchManColorDooleType(+(action.params || 1));
            //     break;
            // case ActionName.SMART_COLOR_MAN_UPDATE:          // 修改手动涂抹颜色值(针对向量图)
            //     mockupApi?.modifyManColorDoole(action.params as string);
            //     break;
            // case ActionName.SMART_COLOR_MAN_PROCESS:        // 生效手动涂抹效果并刷新画板
            //     mockupApi?.processManColorDooleErase((code: number) => {
            //         if(!code){
            //             onDataListener({
            //                 type: EventCallbackParamsType.SMART_COLOR_PROCESS_CALLBACK
            //             })
            //         }
            //         // mockupApi?.stopEraseDraw();
            //     });
            //     break;
            
                // ======  文本 ====
            case ActionName.SWITCH_EDITOR_MODE:   // 切换编辑器模式
                // console.info('switchEditModel', action.params)
                mockupApi?.switchEditModel(action.params == '2' ? 2 : 1);
                break;
            case ActionName.TEXT_SETTING:   // 设置文本属性
                const text = action.params as MockupTextObject ;
                // console.info('..setting', text)
                mockupApi?.modifySelectTextEditParameter(text.fontFamily, text.fontSize, text.lineHeight , text.letterSpacing ,
                        text.fontColor, null, text.textHorizontalAlign, text.textVerticalAlign ,null,null,null,null,null)
                notifyCallback({
                    type: EventCallbackParamsType.EDITOR_CHANGE
                })
                break;
            case ActionName.TEXT_DEFAULT_SETTING: // 设置默认
                const defaultText = action.params as MockupTextObject ;
                mockupApi?.modifyDefaultTextEditParameter(defaultText.fontFamily, defaultText.fontSize , defaultText.lineHeight , defaultText.letterSpacing ,
                    defaultText.fontColor, null, defaultText.textHorizontalAlign, defaultText.textVerticalAlign ,null,null,null,null,null)
                break;
            case ActionName.TEXT_TO_IMAGE : // 转换文本为向量图
                mockupApi?.transformTextToVectorInSelect((code: number, result: any) => {
                    if(!code){
                        onDataListener({
                            type: EventCallbackParamsType.TEXT_TO_IMAGE_CALLBACK
                        })
                    }
                    // console.info('TEXT_TO_IMAGE', code)
                })
        }
    }, [action])
  return (
    <div className="w-full h-full overflow-hidden" ref={parentElement}>
      <div id={divId} style={{width:`${size?.width}px`,height:`${size?.height}px`,display:'block'}} >
        
      </div>
    </div>
  );
}


type CanvasSize = {
    width : number,
    height: number
}

type MockupApiInterface = {
    updateCanvas: () => void, // 手动刷新画布
    initCavas: Function, // 初始化画布
    registerLogCallBack : (callback : (log: string) => void) => void,


    // 设置服务地址(深度图服务地址, 扣图服务地址, AI消除图服务器地址, AI区域分割服务器地址)
    setServerAddress: (depthUrl: string, processImageUrl: string, inpaintUrl: string, aiUrl: string, folderUrl: string) => void,  

    // 设置画板预置title的文本样式
    /*
      textHorizontalAlign 水平排列方式 0是居中，1居左，2居右
      textVerticalAlign 竖直排列方式 0居中，1居上，2居下
      maxfoutSize 字体大小 px
      maxlineHeight行高px
      maxLetterSpacing字间距 px
      maxBordersize 边框线条大小 px
      maxBorderCornerr 园角半径x px
      maxBorderCornerY c园角半径ypx
      offsetx 距离绑定的图片的距离xpX
      offsetY 距离绑定的图片的距离r px 
      offsetWidth 文本距离边框的距离补偿:px
      offsetHeight 文本距离边框的距离补偿，px
    */
    modifyAllTitleEditParameter : (textHorizontalAlign: number, textVerticalAlign: number, maxfontSise: number, maxlineHeight: number, maxletterSpacing : number,
            maxBorderSize: number, maxBorderCornerX: number, maxBordercornerY: number, offsetX: number, offsetY: number) => void

    // 添加图片(type, imageUrl) : type: 1、背景(深度)  2、前景(向量图)
    addImage: (type:number, imageUrl: any, callback: (code: number, result: any) => void) => void,  

    getImageDataByUuid: (uuid: string) => MockupObject

    addVectorImageDatasByArrary: (images: string[], maxCol: number, space: number, width: number, height: number, callback: (code: number, result: any) => void) => void,
    addBackgroundImageDatasByArrary: (mapJsons: string[], maxCol: number, space: number, width: number, height: number, callback: (code: number, result: any) => void) => void,

    /**
     * 批量转底图，根据图片链接集合批量生成 mapjson 点并上传到指定服务器地址
     * 其中code-23表示要上传，结果为上传的信息
     * code=1表示单个执行结束，结果为单个执行后的mapjson
     * code=表示进度，结果为当前进度信息
     * code-2表示全部执行完，结果为全部的mapjson集合
     * code=咦示开始执行
     * @param imageUrls 要添加的图片链接，必须是数组
     * @param folderUrl 图片计算结果上传服务器地址
     * @param timeSpan 每次执行的间隔时间，时间设置为，图片计算的时间 +图片上传的时间
     * @param callback 
     * @returns 
     */
    generateBackgroundImageMapJson : (imageUrls: string[], folderUrl: string, timeSpan: number,  callback: (code: number, result: any) => void) => void,

    // 转mockup
    transformImageTypeInSelect: (callback: (code: number, result: any) => void) => void,
    getSelectImageData : () => any , // 获取选中的图片
    /**
     *  Selected:0,//选中了事件
        Moved:1,//移动结束事件
        Rotated:2,//旋转结束事件
        Scaled:3,//缩放结束事件
        QuitSelected:4,//取消选中事件
        Deleted: 5,//删除事件
        Added:6,//添加事件
        Updated:7,//更新事件
        StartMove:8,//準備移動中
        Moving:9,//正在移动中
        None:10,
        StartScale:11,//开始缩放
        StartRotate:12,//开始旋转
        Scaling:13,//缩放中
        Rotating:14,//旋转中
        EraseDrawing:15, //擦除面板绘制中
        SwitchType:16,//改变类型
        SaveImage:17,//保存图像
        Inited:18,//画板初始化时间
        CanvasScaling:19,//画板缩放
        Undostate:20,//撤销时间
        Redostate:21,//回退事件
        Hidden:22,// 图层隐藏事件
        upload:23,//base64有变化时的通知,
        QuitDrawed: 24,//退出绘制
        changeMouseType:25//鼠标模式类型改变事件，0代表指针模式，1代表拖动模式
        26 // 图层修改触发
        27 // 粘贴事件
        28 // 加载工程结束
        29 // 文字输入完成
     */
    registerEventsCallBack: (callback: (type: number, data: any) => void) => void , // 注册事件(type,data)
    saveSelectImageToPngFile: Function, // 下载图片(fileName)
    saveSelectImageToBase64: (callback: (code: number, result: string) => void) => void ,  // 获取当前选中的图像(如果选中的向量图在底图上,则会返回底图融合后的数据)
    saveSelectImageSrcToBase64: (callback: (code: number, result: string) => void) => void ,  // 获取当前选中的图像

    // modifyVectorImageAlpha: Function, // 设置向量图透明度(废弃)

    // 修改向量图的参数(饱和度;值的范围-1-1, 不透明度;值的范围0-1, 对比度:值的范围-1- 1, 亮度:值的范围-1-1, 贴图方式(0-5))
    modifyVectorImageParameter: (saturation: number, opacity: number, contrast: number, brightness: number, tileMode: number) => void, 

    showLayorPanel: Function,  // 显示图层面板
    closeLayorPanel: Function, // 隐藏图层面板

    captureThrumbailImage : Function,    // 获取画板的缩略图 - (width, height, callback)

    exportProjectData: Function,    // 读取项目数据,0 表示成功  -1表示无数据
    loadProjectData: Function,      // 初始化项目数据(json, callback),callback-其中code=0代表成功，小于0作为错误码返回，result返回错误信息，大于0代表当前处理状态

    position2px: (x: number, y: number) => number[], 
    size2px: (w: number, h: number) => number[],
    rulerToFloat: (x: number) => number,

    undo: () => void,               // 撤销,上一步
    redo: () => void,               // 回退,下一步
    getUndoState: () => boolean,    // 画板数据是否可以撤销 - bool
    getRndoState: () => boolean,    // 画板数据是否可以回退 - bool

    switchMouseType: (type: any) => void, // 切换鼠标交互模式,(mode) 0:指针  1:手势
    merageMockUpImagesToSingleImage: (callback: (code: number, result: any) => void) => void, // 将选中的底图转换成向量图

    updateSelectImage: Function , // 替换选中的图像, (url|file, function) : url|file(地址) , function: code为0表示成功

    // ====== 基础设置 =====
    setRulerScale: (scale: number) => void ,  // 设置画布比例 0.1-5.0之间的值
    showImageLoadingByUuid: (uuid: string, text: string) => void , // 给指定图片显示Loading
    hiddenImageLoadingByUuid: (uuid: string) => void,  // 移除指定图片的Loading

    // ====== 光影 =====
    modifyRenderLight : (light: number) => void,        // 修改光影渲染器的灯光参数 - [0,1]

    // ====== 画笔 =====
    startManAIErase: (callback: (code: number) => void) => void,    // 开启手动消除
    startCicleAIErase: () => void,                                  // 开启圈选消除
    startAIErase: (callback: (code: number) => void) => void,       // 请求AI消除并刷新渲染面板
    stopEraseDraw: () => void,                                      // 关闭并释放绘制面板

    switchAreaEraseType: (type: number) => void,                    // 切换涂抹与擦除(底图): (type): 0擦除  1涂抹
    startAreaErase: (callback: (code: number) => void) => void,     // 区域画笔(底图)
    // startClearErase: Function,                                   // 区域擦除画笔(底图)
    processAreaErase: (callback: (code: number) => void) => void,   // 区域画笔生效接口(底图)

    getDrawPenWidth: () => any,                                     // 获取画笔大小(0.1-50),px
    setDrawPenWidth: (width: any) => void,                          // 设置画笔大小

    // ======= 智能选区 =======
    startAreaEdit :(callback: (code: number ) => void) => void,     // 进入
    // 智能选区面板和手动擦除面板画笔切换(针对向底图)
    // type- 0代表擦除画笔，1代表手动画笔，2代表智能选中画笔,其他参数将不生效
    // callBack- code=0代表成功，1000代表点击事件，1001代表取消事件，小于0代表切换不成功
    switchAreaEditType: (type: number, callback: (code: number) => void) => void, 
    processAreaEdit : (callback: (code: number) => void) => void,  // 处理智能选区或者手动选区结果并刷新画板(针对底图)
    clearAreaEdit: () => void, // 所有区域或者手动擦除参数回归到最开始的值(针对底图)

    // ======= 智能选区废弃 ======
    // startAlAreaErase : (code: any) => {} ,                              // 开启智能底图涂抹(针对底图) - (function) code: 0成功
    // switchAIAreaEraseType: (type: number) => void,                      // 智能底图画笔切换(针对底图) -  (type) type: 0代表擦除画笔，1代表区域画笔
    // analysisAIAreaErase : (callback: (code: number) => void) => void,   // 区域分析(针对底图) - (function) code: 0成功
    // processAIAreaErase: (callback: (code: number) => void) => void,     // 智能底图涂抹生效(针对底图)- (function) code: 0成功


    // ====== 图层 =======
    getFirstItemsData: () => any[],                                         // 图层列表-第一层, return list
    getSecondaryItemsData: (children: any) => any[],                        // 根据获取到的第一层目录去查找第二层数据，获取依附在背景图下的向量图数据, return list
    getSecondaryItemsDatabyUUid: (uuid: string) => any[],                   // 根据第一层uuid查找第二层数据,(uuid) return list
    getAllImageData: () => any[],                                           // 获取所有图像数据, return list

    positioningToImageByUuid: (uuid: string) => void,                       // 定位到指定图层(uuid)

    swapFirstItemDataByUuid: (selectUuid: string, toIndexUuid: string) => void, // 排序更改指定渲染层级到目标层级，同时刷新面板(selectUuid, toIndexUuid),源ID，目标ID

    modifyItemDataLockStateByUuid: (uuid: string, bBlock: boolean) => void,   // 更改指定图层的锁定状态(uuid, bBlock:boolean), 源ID，是否缩写
    getItemDataLockStateByUuid: (uuid: string) => boolean,                    // 获取指定图层的锁定状态(uuid), return boolean

    modifyItemDataHiddenStateByUuid: (uuid: string, bBlock: boolean) => void, // 更改指定图层的隐藏状态(uuid, bBlock:boolean), 源ID，是否缩写
    getItemDataHiddenStateByUuid: (uuid: string) => boolean,                  // 获取指定图层的隐藏状态(uuid), return boolean

    // ======= 智能换色 ======
    startRectOrPointSplitErase : (callback : (code: number) => void ) => void,
    processRectOrPointSplitErase:  (callback : (code: number) => void ) => void,


    startColorEdit: (callback : (code: number) => void ) => void,   // 打开智能换色面板和手动擦除面板(针对向量图)
    // 智能换色面板和手动擦除面板画笔切换(针对向量图
    // type- 0代表擦除画笔，1代表手动画笔，2代表智能选中画笔,其他参数将不生效
    // callBack- code=0代表成功，1000代表点击事件，1001代表取消事件，小于0代表切换不成功
    switchColorEditType: (type: number, callback: (code: number) => void) => void, 
    processColorEdit : (callback: (code: number) => void) => void,  // 处理智能换色或者手动换色结果并刷新画板(针对向里图)
    // 针对区域进行参数调整(针对向里图)(color - #XXXXXX,saturation - 饱和度, opacity - 不透明度,contrast - 对比度,brightness - 亮度) void
    modifyColorEditParameter: (color: string, saturation: number, opacity: number, contrast: number, brightness: number) => void, 
    clearColorEditParameter: () => void, // 所有区域或者手动擦除参数回归到最开始的值(针对向量图)


    // ======= 智能换色（废弃） ========
    startAIColorErase: (callback: (code: number) => void) => void,          // 打开智能换色面板(向量图) - (function) code: 状态0代表初始化成功，1000代表点击区域事件，其他值代表当前状态
    processAIColorErase: (callback: (code: number) => void) => void,        // 处理智能换色结果并刷新画板(向量图) - (function) code: 0成功
    // 针对区域进行参数调整(针对向里图)(color - #XXXXXX,saturation - 饱和度, opacity - 不透明度,contrast - 对比度,brightness - 亮度) void
    modifySelectAreaImageParameter: (color: string, saturation: number, opacity: number, contrast: number, brightness: number) => void, 

    startManColorErase: (callback: (code: number) => void) => void, 
    startManColorDooleErase: (callback: (code: number) => void) => void,    // 开启手动涂抹画板且开启换色功能(针对向量图) - (function) code: 0成功
    switchManColorDooleType: (type: number) => void ,                       // 手动涂抹画笔切换(针对向里图) - (type) type: 0代表擦除画笔，1代表区域画笔
    modifyManColorDoole: (color: string) => void,                           // 修改手动涂抹颜色值(针对向量图) - (color) 颜色值，十六进制
    processManColorDooleErase:  (callback: (code: number) => void) => void, // 生效手动涂抹效果并刷新画板(针对向量图)  - (function) code: 0成功


    // ====== 字体 =======
    switchEditModel : (type: number) => void,  // 切换编辑模式，2、文本模式 非2为图像模式
    // 调整文本样式
    // fontName: 字体名称，需加载字体文件之后设置
    // fontSize: 字体大小(px) lineHeight: 行高(px)  letterSpacing:列间距(px) fontColor:颜色
    // fontWeight: 字体加粗样式 100: Thin 200: ExtraLight  300: Light
    // textHorizontalAlign： 水平对齐方式(0,1,2)   textVerticalAlign: 垂直对齐方式(0,1,2)
    // isDrawBorder : 是否绘制边框，0|1
    // borderSize: 边框宽度
    // borderColor: 边框颜色
    // borderConerX: x方向圆角大小
    // borderCOnerY: y方向圆角大小
    modifySelectTextEditParameter : (fontName: string | null, fontSize: number | null, lineHeight: number | null, letterSpacing: number | null,
            fontColor: string | null, fontWeight: string | null, textHorizontalAlign: number | null, textVerticalAlign: number | null,
            isDrawBorder: number | null, borderSize: number | null, borderColor: string | null, borderConerX: number | null, borderConerY: number | null) => void,

    modifyDefaultTextEditParameter : (fontName: string | null, fontSize: number | null, lineHeight: number | null, letterSpacing: number | null,
        fontColor: string | null, fontWeight: string | null, textHorizontalAlign: number | null, textVerticalAlign: number | null,
        isDrawBorder: number | null, borderSize: number | null, borderColor: string | null, borderConerX: number | null, borderConerY: number | null) => void,
    
    // 将选中的文本转换成向量图
    transformTextToVectorInSelect: (callback: (code: number, result: any) => void ) => void
    
}

export enum ActionName {
    CHANGE_MOUSE_MODE, // 切换鼠标模式

    INIT_EDITOR_DATA, // 初始化编辑器数据
    LOADING_IMAGE, // 加载图片
    ADD_IMAGES, // 批量添加图片
    ADD_BACKGROUNDS, // 批量添加底图
    GENERATE_MOCKUPS, // 批量转mockup
    REPLACE_IMAGE, // 替换图片
    MOCKUP,  // 转Mockup   
    VECTOR, // 转向量图

    IMAGE_SHOW_LOADING, // 图片显示loading
    IMAGE_HIDDEN_LOADING,  // 图片隐藏loading

    VECTOR_REMOVE_BACKGROUD, // 向量图去除背景
    VECTOR_HD_UPSCALE, // 向量图转高清
    VECTOR_ON_MOCKUP_SETTING, // 底图上的向量图属性设置
    DOWNLOAD,  // 下载(Mockup、Frame、图片)
    GET_EDITOR_DATA, // 获取编辑器数据

    UPDATE_RENDER_LIGHT,  // 修改光影渲染

    UPDATE_PANEL_SCALE,  // 修改画布比例
    GET_SELECTED_OBJECT_DATA, // 获取选中的对象数据

    
    VECTOR_AI_ERASE_MAN_START, // 开启手动消除
    VECTOR_AI_ERASE_CIRCLE_START, // 开启手动消除
    SETTING_PEN_SIZE,  // 设置画笔大小
    GET_PEN_SIZE,       // 获取画笔大小
    VECTOR_AI_ERASE_CLEAR, // AI消除
    VECTOR_AI_ERASE_CLOSE, // 关闭画笔


    MOCKUP_AREA_START,      // 开启区域
    MOCKUP_PEN_SWITCH ,  // 切换 涂抹|擦除
    MOCKUP_CONFIRM,     // 确认区域画笔

    MOCKUP_AI_AREA_START,    // 开启智能画笔区域
    MOCKUP_AI_AREA_SEITCH_EDIT_TYPE, // 切换智能编辑模式
    MOCKUP_AI_AREA_PROCESS,  // 生效
    MOCKUP_AI_AREA_RESET,   // 重置

    MOCKUP_AI_PEN_SWITCH ,  // 切换智能画笔 涂抹|擦除(废弃)
    MOCKUP_AI_ANALYSIS,     // 开始分析(废弃)
    MOCKUP_AI_CONFIRM,     // 确认智能画笔区域画笔(废弃)

    TOOLSKIT_UNDO,   // 撤销,上一步
    TOOLSKIT_REDO,   // 回退,下一步
    GET_LAYER_LIST,  // 获取图层列表
    LAYER_LOCKED_STATE, // 图层锁定/解锁
    LAYER_HIDE_STATE,  // 图层隐藏/显示
    LAYER_POSITION,     // 图层定位
    LAYER_SORT,         // 图层排序

    SMART_COLOR_START,              // 打开智能换色面板(向量图) 
    SMART_COLOR_PROCESS,            // 处理智能换色结果并刷新画板(向量图)
    SMART_COLOR_SETTING,            // 针对区域进行参数调整(针对向量图)
    SMART_COLOR_SWITCH_TYPE,        // 切换画板
    SMART_COLOR_RESET,              // 重置 

    // ===== 智能换色（废弃） =======
    SMART_COLOR_MAN_START,          // 开启手动涂抹画板且开启换色功
    SMART_COLOR_MAN_SWITCH_TYPE,    // 手动涂抹画笔切换(针对向里图)
    SMART_COLOR_MAN_UPDATE,         // 修改手动涂抹颜色值(针对向量图)
    SMART_COLOR_MAN_PROCESS,        // 生效手动涂抹效果并刷新画板
    // ===== 智能换色（废弃） =======

    SWITCH_EDITOR_MODE,     // 切换编辑器模式，2: 文本  非2为图像
    TEXT_SETTING,           // 设置文本属性
    TEXT_DEFAULT_SETTING,   // 设置默认文本
    TEXT_TO_IMAGE,          // 转换文本为向量图
}


/**
 * 操作指令
 */
export type Action = {
    /**
     * 指令名称
     */
    name: ActionName,
    /**
     * 指令参数
     */
    params ?: string | FineTuningObject | MockupTextObject | LayerItem | ImagesObject | BatchMockupsObject
}


export type MockupObject = MockupBaseObject & FineTuningObject ;
export type MockupTextObject = MockupBaseObject & {
    fontFamily: string,
    fontColor: string,
    fontSize: number,
    lineHeight: number,
    letterSpacing: number,
    textHorizontalAlign: number,
    textVerticalAlign: number,
    text: string
}

type MockupBaseObject = {
    uuid: string,
    type: number,
    mImageWidth: number,
    mImageHeight: number,
    mImageSrcWidth: number,
    mImageSrcHeight: number,
    mPosX: number, // 单位为mm
    mPosY: number, // 单位为mm
    mShowWidth: number,  
    mShowHeight: number,
    globalLeft: number , // 相对浏览器内容的left 像素
    globalTop: number , // 相对浏览器内容的Top 像素
    globalWidth: number,
    globalHeight: number,

    mImageUrl?: string,

    mapUUId: string, // 当前向量图指向的底图(置于底图上)

    parent ?: MockupObject
}

export type FineTuningObject = {
    mapUUId?: string, // 当前向量图指向的底图(置于底图上)
    opacity: number, // 透明度
    saturation: number, // 饱和度
    brightness: number, // 亮度
    contrast: number,   // 对比度
    tileMode ?: number, // 排列方式
    spacing ?: number   // 间隔
}

export type SmartColorFineTuningObject = {
    color ?: string
} & FineTuningObject

export type ImagesObject = {
    images?: string[], 
    mapJsons ?: any[],
    maxCol: number, 
    space: number, 
    width: number, 
    height: number
}

export type BatchMockupsObject = {
    images : string[],
    folderUrl : string,
    timeSpan : number
}


export type EventCallbackParams = {
    type: EventCallbackParamsType,
    callbackType ?: number,
    data?: MockupObject | ItemBase64 | string | boolean | any | null,
    list?: any[]
}

export type ItemBase64 = {
    md5: string,
    base64: Uint8Array,
    type: number,
    imageData : any
}

export enum EventCallbackParamsType {
    EDITOR_INIT_FINISHED = 100, // 编辑器初始化成功
    OBJECT_SELECT = 101,  // 对象选择
    OBJECT_CANCEL_SELECT = 102, // 取消选择
    ACTION_FINISH = 103,  // Action指令完成
    EDITOR_CHANGE = 104,  // 编辑器有数据变化
    GET_EDITOR_DATA_CALLBACK = 105,  // 获取编辑器数据后的回调
    DOWNLOAD_CALLBACK = 106, // 下载之后的回调
    GET_PEN_SIZE_CALLBACK = 107, // 获取画笔大小的回调

    PEN_CONFIRM_CALLBACK = 108, // AI消除成功后的回调(向量图) | 确认区域画笔成功后的回调(底图)

    ITEM_BASE64_CHANGE = 109,  // 当图像有base64变化时的回调，需要暂存
    MOCKUP_COVERTING = 110,     // 正在转mockup中
    VECTOR_REMOVE_BACKGROUD_CALLBACK = 111, // 去除背景之后的回调
    MOUSE_CHANGE_CALLBACK = 112, // 画板行为切换时的回调(选择/拖动)

    MOCKUP_TO_VECTOR_CALLBACK = 113, // 底图转向量图后的回调
    VECTOR_HD_UPSCALE_CALLBACK = 114, // 向量图转高清后的回调


    ADD_ELEMENT_SUC_CALLBACK = 116, // 添加元素成功后的回调

    MOVED_CALLBACK = 117,  // 元素拖动结束后的回调

    GET_SELECTED_OBJECT_DATA_CALLBACK = 118, // 获取选中元素的的回调
    MOCKUP_AI_AREA_READY = 119,    // 已经就绪
    MOCKUP_AI_AREA_CHOICE_STATUS = 120,  // 智能换色的部位选中状态
    MOCKUP_AI_AREA_PROCESS_CALLBACK = 121, // 智能换色生效后的回调(包括区域及涂抹)

    PANEL_SCALE_CALLBACK = 200,  // 画布缩放时的回调
    GET_LAYER_LIST_CALLBACK = 201, // 获取图层列表的回调
    LAYER_MODIFY_CALLBACK = 202,  // 画布变动时的回调

    SMART_COLOR_AI_READY = 300,  // 智能换色 分割服务已就绪
    SMART_COLOR_CHOICE_STATUS = 301,  // 智能换色的部位选中状态
    SMART_COLOR_PROCESS_CALLBACK = 302, // 智能换色生效后的回调(包括区域及涂抹)

    ERASE_DRAW_EXIT_CALLBACK = 303,  // 画笔退出后的回调

    TEXT_TO_IMAGE_CALLBACK = 400,  // 文本转图片后的回调
    TEXT_EDITING_CALLBACK = 401,  // 文字编辑中的回调
    TEXT_EXIT_CALLBACK = 402,  // 文字退出编辑的回调
}
